import { ModelRecipeFilterInput } from '@akin-home/amplify';
import { OptionModel } from '@akin-home/options';
import { MealPlanPreferences } from '@akin-home/recipes';

import { getAllergyOptionIDsForAllergyPreferences } from './getAllergyOptionIDsForAllergyPreferences';

interface Params {
  preferences: MealPlanPreferences;

  allergy_options: OptionModel[];
  special_diet_options?: OptionModel[];
}

export const getRecipeFilterFromMealPreferences = (
  params: Params
): ModelRecipeFilterInput | undefined => {
  const { preferences, allergy_options } = params;

  const filter: ModelRecipeFilterInput = {
    and: [],
  };

  if (preferences.budget) {
    filter.and?.push({ budget: { le: preferences.budget } });
  }

  /** Filter out allergies */
  if (preferences.allergies?.length) {
    const allergy_ids = getAllergyOptionIDsForAllergyPreferences({
      allergy_options,
      allergy_preferences: preferences.allergies,
    });

    if (allergy_ids.length) {
      allergy_ids.forEach((allergy_id) => {
        filter.and?.push({
          allergyIDs: { notContains: allergy_id },
        });
      });
    }
  }

  return filter.and?.length ? filter : undefined;
};
